module.exports = __webpack_public_path__ + "static/water_glacier14-5168c6f2d95125808c0bc7168451dc10.jpg";